import { ComposerHeaderProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: ComposerHeaderProps = {};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as ComposerHeaderProps,
  },
];

export const testkitTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      backButtonValue: 'Back to Social Posts',
    } as ComposerHeaderProps,
  },
];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
